import axios from 'axios';
import {getAPIURL} from '../settings';

export interface FType {
    mimeType: string,
    fileExtension: string,
    name: string,
}

export let FileType = {
    STEP: {mimeType: "data:application/step", fileExtension: ".stp", name: "STEP"} as FType,
    IGES: {mimeType: "data:application/iges", fileExtension: ".igs",name: "IGES"} as FType
}

export function DownloadCADFile(fileType: FType, matNr: string, onError:Function) {  
    
    axios(getAPIURL() + `/api/download/` + matNr + "/" + fileType.name, {
        method: 'GET',
        responseType: 'blob' //Force to receive data in a Blob Format
    })
    .then(response => {
    //Create a Blob from the PDF Stream
        const file = new Blob(
          [response.data], 
          {type: fileType.mimeType});
    //Build a URL from the file
    var link = window.document.createElement('a');
    const fileURL = URL.createObjectURL(file);

    link.href = fileURL;
    link.download='KTR_' + matNr + fileType.fileExtension;
    document.body.appendChild(link);
    //open url in new window 
    link.click();
    //remove link element from body
    document.body.removeChild(link);
    })
    .catch(error => {
        //call error function if something is wrong.
        onError(error);
    });


}